import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {MenusPlanning2Service} from "../../../core/services/gestionmenus/menus-planning2.service";
import {UtilsService} from "../../../core/utils/utils.service";
import {BehaviorSubject, combineLatest, Observable, Subscription} from "rxjs";
import {DATEPICKER_FR} from "../../../core/constants";
import {debounceTime, filter, switchMap} from "rxjs/operators";
import {DisplayEgalimResponse} from "../../../core/dtos/gestionmenus/planning/egalim/display-egalim-response-dto";
import {UnitesDeProductionService} from "../../../core/services/entities/unites-de-production.service";
import {GraphQLService} from "../../../core/services/technique/graphql.service";
import {MenusToolbarService} from "../../../core/services/gestionmenus/menus-toolbar.service";
import {SeuilEgalimDto} from "../../../core/dtos/egalim/seuil-egalim-dto";


@Component({
    selector: 'yo-menus-egalim',
    templateUrl: './menus-egalim.component.html',
    styleUrls: ['./menus-egalim.component.scss'],
    standalone: false
})
export class MenusEgalimComponent implements OnInit, OnDestroy {

  period: string;
  subAnalyseEgalim: Subscription;
  subChangeValues: Subscription;
  private subRegime: Subscription;


  selectedPeriode: Date[] = [new Date(), new Date()];
  effectif: number = 1;
  localeFr: any = DATEPICKER_FR;
  idContratMenuConvive: number;

  dataGraphic: DisplayEgalimResponse;

  subjectSelectedPeriode: BehaviorSubject<any> = new BehaviorSubject(undefined);
  selectedPeriodes$: Observable<any> = this.subjectSelectedPeriode.asObservable();

  subjectEgalimThreshold: BehaviorSubject<any> = new BehaviorSubject(undefined);
  subjectEgalimThreshold$: Observable<any> = this.subjectEgalimThreshold.asObservable();

  egalimThresholdBio: number = 20;

  egalimThresholdSustainableProducts: number = 50;

  egalimThresholdPoissonViandeDurable: number = 60;

  seuils: SeuilEgalimDto[] = [new SeuilEgalimDto('Seuil Bio', this.egalimThresholdBio),
    new SeuilEgalimDto('Seuil Produits Durables', this.egalimThresholdSustainableProducts),
    new SeuilEgalimDto('Seuil Viandes et Poissons Durables', this.egalimThresholdPoissonViandeDurable)]

  private selectedRegime: number;
  regime$ = this.menusToolbarSvc.regime$;

  udp: string;

  constructor(public mp2Svc: MenusPlanning2Service,
              private udpSvc: UnitesDeProductionService,
              public utils: UtilsService,
              private graphQlSvc: GraphQLService,
              private cd: ChangeDetectorRef,
              private menusToolbarSvc: MenusToolbarService,) {
  }

  ngOnInit(): void {
    this.idContratMenuConvive = this.mp2Svc.planningMenus.contratMenuConviveList && this.mp2Svc.planningMenus.contratMenuConviveList.length ? this.mp2Svc.planningMenus.contratMenuConviveList[0].id : -1;
    if (this.idContratMenuConvive > -1)
      this.graphQlSvc.sendQuery(`
        {
          allUnitesProduction(filters: {
            idsSites: [${this.mp2Svc.planningMenus.contratMenuConviveList[0].contratMenuSiteId}]
          }) {
            libelle,
            egalimThresholdBio,
            egalimThresholdSustainableProducts,
            egalimThresholdPoissonViandeDurable
          }
        }
    `).subscribe(response => {
        const udp: any = response.allUnitesProduction[0];
        this.udp = udp.libelle;
        this.egalimThresholdBio = udp.egalimThresholdBio;
        this.egalimThresholdSustainableProducts = udp.egalimThresholdSustainableProducts;
        this.egalimThresholdPoissonViandeDurable = udp.egalimThresholdPoissonViandeDurable;
        const dates = this.mp2Svc.planningMenus.dateList;
        this.selectedPeriode = [new Date(dates[0].date), new Date(dates[dates.length - 1].date)];
        this.getRegime();
        this.findAnalyseEgalimSubscription();
        this.changeValuesSubscription();
      });
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subAnalyseEgalim);
    this.utils.unsubscribe(this.subChangeValues);
  }

  findAnalyseEgalimSubscription = () => {
    this.subAnalyseEgalim = this.mp2Svc.findAnalyseEgalim(this.idContratMenuConvive, this.effectif, this.selectedPeriode[0], this.selectedPeriode[1], this.selectedRegime)
      .subscribe(response => {
        this.dataGraphic = response.one;
      });
  }

  changeValuesSubscription: () => void = () => {
    this.dataGraphic = null;
    const all$ = combineLatest([this.selectedPeriodes$, this.subjectEgalimThreshold$]);
    this.subChangeValues = all$.pipe(
      debounceTime(500),
      filter(data => this.effectif && this.selectedPeriode && this.selectedPeriode.length > 0),
      switchMap(response => this.mp2Svc.findAnalyseEgalim(this.idContratMenuConvive, this.effectif, this.selectedPeriode[0], this.selectedPeriode[1], this.selectedRegime, this.egalimThresholdBio, this.egalimThresholdSustainableProducts, this.egalimThresholdPoissonViandeDurable))
    ).subscribe(response => {
      this.cd.markForCheck();
      this.dataGraphic = response.one;
      this.cd.markForCheck();
    });
  }

  canDisplay: () => (boolean) = () =>
    !this.utils.isNullOrEmpty(this.mp2Svc.planningMenus) && !this.utils.isCollectionNullOrEmpty(this.mp2Svc.planningMenus.contratMenuConviveList);


  changeSeuil = (seuilUpdated: SeuilEgalimDto[]): void => {
    this.seuils = seuilUpdated;
    this.egalimThresholdBio = this.seuils[0].seuil;
    this.egalimThresholdSustainableProducts = this.seuils[1].seuil;
    this.egalimThresholdPoissonViandeDurable = this.seuils[2].seuil;
    this.subjectEgalimThreshold.next(seuilUpdated);
  }

  getText = (item: any, value: string) => {
    switch (item.index) {
      case 0:
        return `Pourcentage de produits durables ${value} % (${this.dataGraphic.totalMontantProduitsDurablesPeriod} €)`;
      case 1:
        return `Pourcentage de produits bio ${value} % (${this.dataGraphic.totalMontantProduitsBioPeriod} €)`;
      default:
        return `Pourcentage de viandes et poissons durables ${value} % (${this.dataGraphic.totalMontantProduitsPoissonViandePeriod} €)`;
    }
  }

  customizeTooltip = (arg): any => ({
    text: this.getText(arg, arg.valueText),
  });

  customizeText = (arg): any => this.getText(arg.item, arg.text);

  customizeTextLabel: (arg) => string = arg => `${arg.valueText} %`;

  getPeriod = ():string => "Période du " + this.selectedPeriode[0].toLocaleDateString() + " au " + this.selectedPeriode[1].toLocaleDateString();

  private getRegime() {
    this.subRegime = this.regime$.subscribe(response => {
      this.selectedRegime = response.id;
    });

  }

  onDateFilterValueChange = (data: any) => {
    this.selectedPeriode = [data[0], data[1]];
    this.subjectSelectedPeriode.next(this.selectedPeriode);
  };

}
